import { Command, ModelBase, TnEngineExtraContext } from "pytha";
import { BaseCommand } from "./base-command";

export class MonixUpdatePrimitivesCommand extends BaseCommand {

    entities: ModelBase[] = [];
    entitiesNew: ModelBase[] = [];
    extraContext: TnEngineExtraContext;
    onExecuteCallback: () => void;
    onUndoCallback: () => void;

    constructor(entities: ModelBase[], entitiesNew: ModelBase[], executeCallback?: () => void, undoCallback?: () => void) {
        super();
        this.extraContext = TnEngineExtraContext.getInstance();
        this.editor = this.extraContext.getCurrentViewEditor();
        this.entities = entities;
        this.entitiesNew = entitiesNew;
        this.onExecuteCallback = executeCallback || (() => { });
        this.onUndoCallback = undoCallback || (() => { });
    }

    execute(): void {
        if (this.entitiesNew.length === 0 || this.entities.length === 0) return;
        this.editor.removeObjects(this.entities);
        this.editor.addObjects(this.entitiesNew);
        this.editor.listeners.signals.needRender.dispatch('redraw');
        this.onExecuteCallback();
    }
    undo(): void {
        if (this.entitiesNew.length === 0 || this.entities.length === 0) return;
        this.editor.removeObjects(this.entitiesNew);
        this.editor.addObjects(this.entities);
        this.editor.listeners.signals.needRender.dispatch('redraw');
        this.onUndoCallback();
    }

}